import { alpha, Button, Divider, Stack, styled, Typography } from '@mui/material';
import { GLASS_BLUR } from 'src/constants/glass';

const ClosedInputBackground = styled(Stack, {
  name: 'ClosedInputBackground',
})(({ theme }) => ({
  alignItems: 'end',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  overflow: 'visible',
  backgroundColor: alpha(theme.palette.custom.OV.sys.surfaceContainerLowest, 0.62),
  backdropFilter: GLASS_BLUR,
  WebkitBackdropFilter: GLASS_BLUR,
  border: `1px solid ${alpha(theme.palette.custom.OV.sys.outlineVariant, 0.75)}`,
  '@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px)))': {
    backgroundColor: theme.palette.custom.OV.sys.surfaceBright,
  },
}));

const StyledButton = styled(Button, { name: 'ClosedInputSendButton' })(({ theme }) => ({
  background: theme.palette.custom.OV.sys.secondary,
  flexShrink: 0,
  marginTop: theme.spacing(1),
}));

interface ClosedInputProps {
  buttonText: string;
}

export const ClosedInput = ({ buttonText }: ClosedInputProps) => {
  return (
    <ClosedInputBackground>
      <Divider
        sx={{
          width: '100%',
        }}
      />
      <StyledButton variant="contained" disabled>
        <Typography variant="body2" sx={{ fontWeight: 900 }}>
          {buttonText}
        </Typography>
      </StyledButton>
    </ClosedInputBackground>
  );
};
